<template>
  <a-alert :message="messsage" type="error" show-icon v-bind="dynamicAttrs" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { app } from '@/libs/app';
import { Alert } from 'ant-design-vue';
import './styles.scss';

app.use(Alert);

export default defineComponent({
  name: 'ErrorMessage',
  props: {
    dynamicAttrs: {},
    messsage: String,
  },
});
</script>
